export const STRATEGIES = [
  {
    type: 'LONG' as const,
    title: 'DCA 기본형 m1.5',
    symbol: 'BTCUSDT',
    leverage: 20,
    entryCount: 11,
    entryMultiplier: 1.5,
    entryInterval: 0.48,
    takeProfit: 15,
    yield90d: 228.74
  },
  {
    type: 'SHORT' as const,
    title: 'DCA 기본형 m1.5',
    symbol: 'BTCUSDT',
    leverage: 20,
    entryCount: 11,
    entryMultiplier: 1.5,
    entryInterval: 0.48,
    takeProfit: 15,
    yield90d: 162.55
  },
  {
    type: 'LONG' as const,
    title: 'DCA 공격형 m2.0',
    symbol: 'BTCUSDT',
    leverage: 20,
    entryCount: 7,
    entryMultiplier: 2,
    entryInterval: 0.75,
    takeProfit: 20,
    yield90d: 198.74
  },
  // {
  //   type: 'BOTH' as const,
  //   title: 'ETH DCA 양방향',
  //   symbol: 'ETHUSDT',
  //   leverage: 20,
  //   entryCount: 11,
  //   entryMultiplier: 1.5,
  //   entryInterval: 0.48,
  //   takeProfit: 15,
  //   yield90d: 394.5
  // },
  {
    type: 'BOTH' as const,
    title: 'DCA 양방향(기본형) m1.5',
    symbol: 'BTCUSDT',
    leverage: 20,
    entryCount: 11,
    entryMultiplier: 1.5,
    entryInterval: 0.48,
    takeProfit: 15,
    yield90d: 213.3
  },
  {
    type: 'BOTH' as const,
    title: 'DCA 양방향(공격형) m2.0',
    symbol: 'BTCUSDT',
    leverage: 20,
    entryCount: 7,
    entryMultiplier: 2.0,
    entryInterval: 0.75,
    takeProfit: 20,
    yield90d: 0
  },
  {
    type: 'BOTH' as const,
    title: 'DCA 양방향(물타기배수축소) m2.0',
    symbol: 'BTCUSDT',
    leverage: 20,
    entryCount: 5,
    entryMultiplier: 2.0,
    entryInterval: 0.8,
    takeProfit: 20,
    yield90d: 0
  }
];
